<template>
  <div :class="showDialog ? 'list-wrap overflow' : 'list-wrap' ">
    <span class="tc title w100">玉昆钢铁订单管理系统</span>
    <Detail @close="showDialog = false" @refresh="start" v-show="showDialog" :data="detail"></Detail>
    <el-dialog class="check-wrap" :title="`筛选日期`" :visible.sync="showCheck">
      <check-date :allData="totalList"></check-date>
    </el-dialog>
    <div v-show="showDel" class="del-wrap fixed">
      <div class="inner">
        <span>提示</span>
        <span class="tc w100">确定删除该条数据吗？请谨慎操作</span>
        <div>
          <span class="btn" @click="toDel">确定</span>
          <span class="btn" @click="cancel">取消</span>
        </div>
      </div>
    </div>
    <div class="option">
      <input type="text" v-model.trim="value" placeholder="请输入姓名">
      <span class="btn" @click="search(value)">搜索</span>
      <span class="option-item ml40">库存：{{getRest}}t</span>
      <span class="option-item ml40">总交易额：{{getTotal}}</span>
      <span class="ml40 btn" @click="addItem">新增交易</span>
      <span class="btn ml40 btn-check" @click="showCheck = true">打开筛选</span>
    </div>
    <ListItem :isHead="true" :data="headOption"></ListItem>
    <ListItem 
      :class="index == 0 && item.name == totalList[0].name ? 'in' : 'out'"
      v-for="(item, index) in list" 
      :key="index" 
      :data="item" 
      :home="true"
      @onClick="clickItem($event, index)">
    </ListItem>
  </div>
</template>

<script>
import ListItem from '@/components/ListItem.vue';
import Detail from '@/components/Detail.vue';
import checkDate from '@/components/checkDate.vue';
import { getStorage, setStorage } from '@/utils/index';

export default {
  name: 'List',
  components: {
    ListItem,
    Detail,
    checkDate
  },
  data: function () {
    return {
      showDialog: false,
      showDel: false,
      currentDelItem: {},
      detail: {
      },
      value: '',
      headOption: {
        name: '姓名',   // 姓名
        address: '地址',    // 地址
        phone: '电话',  // 电话
        order: '预定量',
        sended: '成交量',
        totalPrice: '交易额', // 总价
        rest: '未完成量',
        tip: '备注',
        operate: '操作'
      },
      list: [],
      totalList: [],
      showCheck: false,
      scrollObj: {
        target: {
          scrollTop: 0
        },
        top: 0
      }
    }
  },
  mounted() {
    this.start();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll.bind(this));
  },
  computed: {
    getRest() {
      const list = this.totalList;
      if(list.length <= 0) return 0;

      let total = 0;
      list[0].list && list[0].list.map(item => {
        item.amount && (total += item.amount);
      });

      let used = 0;
      list.slice(1).forEach(item => {
        item.list && item.list.map(ware => {
          const date = new Date(ware.date).getTime();
          const last = new Date('2020-2-16').getTime();
          ware.amount && date > last && (used += ware.amount);
        });
      });

      return (total - used).toFixed(4);
    },
    getTotal() {
      if(this.totalList.length <= 0) return 0;

      let total = 0;
      this.totalList.slice(1).forEach(item => {
        item.list.map(ware => {
          const date = new Date(ware.date).getTime();
          const last = new Date('2020-2-16').getTime();
          ware.amount && date > last &&  ware.singlePrice && (total += (ware.amount * ware.singlePrice));
        });
      });

      return total.toFixed(4);
    }
  },
  watch: {
    showDialog: {
      handler(show) {
        if (!show) {
          this.$nextTick(() => {
            this.scrollObj.target.scrollTop = this.scrollObj.top;
          });
        }
      }
    }
  },
  methods: {
    start() {
      getStorage().then(res => {
        this.list = res;
        this.totalList = res;
        this.scrollObj.target = document.querySelector('html');
        window.addEventListener('scroll', this.onScroll.bind(this));
      });
    },
    onScroll() {
      if (this.scrollObj.target.scrollTop === 0) {
        return;
      }
      this.scrollObj.top = this.scrollObj.target.scrollTop;
    },
    clickItem(type, index) {
      this.currentDelItem = this.list[index];
      if(type == 'edit') {
        this.detail = this.list[index];
        this.showDialog = true;
      } else {
        // this.showDel = true;
        this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.toDel();
        }).catch(() => {
                  
        });
      }
    },
    search(val) {
      getStorage().then(res => {
        if(!val) {
          this.list = res;
          return;
        }
        this.list = res.filter((item, index) => {
          return item.name && item.name.match(val);
        });
      })
    },
    addItem() {
      this.detail = {};
      this.showDialog = true;
    },
    cancel() {
      this.showDel = false;
    },
    toDel() {
      this.list = this.list.filter(item => {
        return item != this.currentDelItem;
      });
      setStorage(this.list).then(() => {
        this.start();
        this.cancel();
        this.$message.success('删除成功');
      });
    }
  }
}
</script>

<style>
.check-wrap .el-dialog {
  min-width: 800px;
}
.tc {
  text-align: center;
}
.title{
  height: 60px;
  line-height: 60px;
  letter-spacing: 5px;
}
.option {
  width: 100%;
  display: flex;
  align-items: center;
  height: 60px;
}
.ml40 {
  margin-left: 40px;
}
input {
  height: 32px;
  padding: 0 10px;
  border: 1px solid #eee;
  margin: 0 30px;
}
.w100 {
  width: 100%;
}
.list-wrap {
  width: 100%;
  padding-bottom: 100px;
}
.btn {
  cursor: pointer;
  height: 32px;
  line-height: 32px;
  color: #fff;
  padding: 0 10px;
  background: #51a9dc;
  border-radius: 5px;
}
.fixed {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background: rgba(0, 0, 0, .5);
}
.del-wrap .inner {
  width: 300px;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 20px;
}
.del-wrap .inner .btn {
  margin-top: 50px;
  width: 71px;
  text-align: center;
}
.del-wrap .inner .tc {
  margin-top: 30px;
}
.del-wrap .inner div {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0 15px;
  align-items: center;
  justify-content: space-between;
}
.in {
  background: #63cc6b;
}
.btn-check::before {
  content: '';
  width: 1px;
  height: 21px;
  background: #aaa;
  display: inline-block;
  transform: translateX(-30px) translateY(6px);
}
.overflow {
  overflow: hidden;
  height: 100%;
}
</style>